import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export default function useIsModal() {
    const { themeName } = useContext(ThemeContext);
    return ['upsell', 'modal', 'sww'].includes(themeName ?? '');
}
